/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.50
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from "../ApiClient";
import {ChecklistCosoFattoreQualificanteDTO} from '../model/ChecklistCosoFattoreQualificanteDTO';
import {ChecklistDTO} from '../model/ChecklistDTO';
import {ChecklistMonitorDTO} from '../model/ChecklistMonitorDTO';
import {ChecklistPostRequestDTO} from '../model/ChecklistPostRequestDTO';
import {RestBodyResponseUtil} from '../model/RestBodyResponseUtil';

/**
* ChecklistServices service.
* @module api/ChecklistServicesApi
* @version v0
*/
export class ChecklistServicesApi {

    /**
    * Constructs a new ChecklistServicesApi. 
    * @alias module:api/ChecklistServicesApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the checkAssessmentIsFrozen operation.
     * @callback moduleapi/ChecklistServicesApi~checkAssessmentIsFrozenCallback
     * @param {String} error Error message, if any.
     * @param {'Boolean'{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get list of checklists for checklist monitor page
     * Request to get the list of checklists holding the information needed to fill the checklist monitor page.
     * @param {Number} fiscalYear 
     * @param {Number} checklistPeriodId 
     * @param {module:api/ChecklistServicesApi~checkAssessmentIsFrozenCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    checkAssessmentIsFrozen(fiscalYear, checklistPeriodId, callback) {
      
      let postBody = null;
      // verify the required parameter 'fiscalYear' is set
      if (fiscalYear === undefined || fiscalYear === null) {
        throw new Error("Missing the required parameter 'fiscalYear' when calling checkAssessmentIsFrozen");
      }
      // verify the required parameter 'checklistPeriodId' is set
      if (checklistPeriodId === undefined || checklistPeriodId === null) {
        throw new Error("Missing the required parameter 'checklistPeriodId' when calling checkAssessmentIsFrozen");
      }

      let pathParams = {
        
      };
      let queryParams = {
        'fiscalYear': fiscalYear,'checklistPeriodId': checklistPeriodId
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = 'Boolean';

      return this.apiClient.callApi(
        '/api/checklist/checkAssessmentIsFrozen', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the confirmed operation.
     * @callback moduleapi/ChecklistServicesApi~confirmedCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RestBodyResponseUtil{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Set checklist state from &#x27;Work in Progress&#x27; (WIP) to &#x27;Confirmed&#x27;
     * Request to change the status of a checklist from &#x27;Work in Progress&#x27; (WIP) to &#x27;Confirmed&#x27; based on the id passed as path variable. Checklist state must be &#x27;Work in Progress&#x27; (WIP) to use this request.
     * @param {Number} checklistId 
     * @param {module:api/ChecklistServicesApi~confirmedCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    confirmed(checklistId, callback) {
      
      let postBody = null;
      // verify the required parameter 'checklistId' is set
      if (checklistId === undefined || checklistId === null) {
        throw new Error("Missing the required parameter 'checklistId' when calling confirmed");
      }

      let pathParams = {
        'checklistId': checklistId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = RestBodyResponseUtil;

      return this.apiClient.callApi(
        '/api/checklist/{checklistId}/confirmed', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the deleteChecklist operation.
     * @callback moduleapi/ChecklistServicesApi~deleteChecklistCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RestBodyResponseUtil{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete checklist by id
     * Delete the checklist with id equals to the one passed as path variable.
     * @param {Number} checklistId 
     * @param {module:api/ChecklistServicesApi~deleteChecklistCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    deleteChecklist(checklistId, callback) {
      
      let postBody = null;
      // verify the required parameter 'checklistId' is set
      if (checklistId === undefined || checklistId === null) {
        throw new Error("Missing the required parameter 'checklistId' when calling deleteChecklist");
      }

      let pathParams = {
        'checklistId': checklistId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = RestBodyResponseUtil;

      return this.apiClient.callApi(
        '/api/checklist/{checklistId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the duplicateChecklist operation.
     * @callback moduleapi/ChecklistServicesApi~duplicateChecklistCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ChecklistDTO{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Duplicate checklist by id
     * Duplicate the checklist with id equals to the one passed as path variable.
     * @param {Number} checklistId 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.includeAnswers  (default to <.>)
     * @param {module:api/ChecklistServicesApi~duplicateChecklistCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    duplicateChecklist(checklistId, opts, callback) {
      opts = !(opts === null || opts === undefined) ? opts : true;
      let postBody = null;
      // verify the required parameter 'checklistId' is set
      if (checklistId === undefined || checklistId === null) {
        throw new Error("Missing the required parameter 'checklistId' when calling duplicateChecklist");
      }

      let pathParams = {
        'checklistId': checklistId
      };
      let queryParams = {
        'includeAnswers': opts
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = ChecklistDTO;

      return this.apiClient.callApi(
        '/api/checklist/{checklistId}/duplicate', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the evaluated operation.
     * @callback moduleapi/ChecklistServicesApi~evaluatedCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RestBodyResponseUtil{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Set checklist state from &#x27;Confirmed&#x27; or &#x27;Under Review&#x27; to &#x27;Evaluated&#x27;
     * Request to change the status of a checklist from &#x27;Confirmed&#x27; or &#x27;Under Review&#x27; to &#x27;Evaluated&#x27; based on the id passed as path variable. Checklist state must be &#x27;Confirmed&#x27; or &#x27;Under Review&#x27; to use this request.
     * @param {Number} checklistId 
     * @param {module:api/ChecklistServicesApi~evaluatedCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    evaluated(checklistId, callback) {
      
      let postBody = null;
      // verify the required parameter 'checklistId' is set
      if (checklistId === undefined || checklistId === null) {
        throw new Error("Missing the required parameter 'checklistId' when calling evaluated");
      }

      let pathParams = {
        'checklistId': checklistId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = RestBodyResponseUtil;

      return this.apiClient.callApi(
        '/api/checklist/{checklistId}/evaluated', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getChecklistById operation.
     * @callback moduleapi/ChecklistServicesApi~getChecklistByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ChecklistDTO{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get Checklist info by id
     * Request to get checklist information based on the id passed as path variable.
     * @param {Number} checklistId 
     * @param {module:api/ChecklistServicesApi~getChecklistByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getChecklistById(checklistId, callback) {
      
      let postBody = null;
      // verify the required parameter 'checklistId' is set
      if (checklistId === undefined || checklistId === null) {
        throw new Error("Missing the required parameter 'checklistId' when calling getChecklistById");
      }

      let pathParams = {
        'checklistId': checklistId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = ChecklistDTO;

      return this.apiClient.callApi(
        '/api/checklist/{checklistId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getChecklistCosoHierarchyById operation.
     * @callback moduleapi/ChecklistServicesApi~getChecklistCosoHierarchyByIdCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ChecklistCosoFattoreQualificanteDTO>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get checklist COSO hierarchy by id
     * Request to get the full COSO hierarchy (qualitative/quantitative questions) associated to a checklist based on the id passed as path variable.
     * @param {Number} checklistId 
     * @param {module:api/ChecklistServicesApi~getChecklistCosoHierarchyByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getChecklistCosoHierarchyById(checklistId, callback) {
      
      let postBody = null;
      // verify the required parameter 'checklistId' is set
      if (checklistId === undefined || checklistId === null) {
        throw new Error("Missing the required parameter 'checklistId' when calling getChecklistCosoHierarchyById");
      }

      let pathParams = {
        'checklistId': checklistId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = [ChecklistCosoFattoreQualificanteDTO];

      return this.apiClient.callApi(
        '/api/checklist/{checklistId}/question', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getChecklistMonitor operation.
     * @callback moduleapi/ChecklistServicesApi~getChecklistMonitorCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ChecklistMonitorDTO>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get list of checklists for checklist monitor page
     * Request to get the list of checklists holding the information needed to fill the checklist monitor page.
     * @param {module:api/ChecklistServicesApi~getChecklistMonitorCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getChecklistMonitor(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = [ChecklistMonitorDTO];

      return this.apiClient.callApi(
        '/api/checklist/monitor', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getCountToEvaluate operation.
     * @callback moduleapi/ChecklistServicesApi~getCountToEvaluateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RestBodyResponseUtil{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns a count of checklist in &#x27;To Evaluate&#x27; status
     * Returns a count of checklist in &#x27;To Evaluate&#x27; status in the field &#x27;message&#x27; of the response
     * @param {module:api/ChecklistServicesApi~getCountToEvaluateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getCountToEvaluate(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = RestBodyResponseUtil;

      return this.apiClient.callApi(
        '/api/checklist/to-evaluate/count', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the newChecklist operation.
     * @callback moduleapi/ChecklistServicesApi~newChecklistCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ChecklistDTO{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Add new Checklist by info from body
     * Add a Checklist based on the body request (ChecklistPostRequestDTO) sent by the user, the request holds the ids of the checklist relationships and some checklist field (remember to exclude id from the body or set it to null).
     * @param {module:model/ChecklistPostRequestDTO} body 
     * @param {module:api/ChecklistServicesApi~newChecklistCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    newChecklist(body, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling newChecklist");
      }

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['*/*'];
      let returnType = ChecklistDTO;

      return this.apiClient.callApi(
        '/api/checklist', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the toEvaluate operation.
     * @callback moduleapi/ChecklistServicesApi~toEvaluateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RestBodyResponseUtil{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Set checklist state from &#x27;Draft&#x27; to &#x27;To Evaluate&#x27; by id
     * Request to change the status of a checklist from &#x27;Draft&#x27; to &#x27;To Evaluate&#x27; based on the id passed as path variable. Checklist state must be &#x27;Draft&#x27; to use this request.
     * @param {Number} checklistId 
     * @param {module:api/ChecklistServicesApi~toEvaluateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    toEvaluate(checklistId, callback) {
      
      let postBody = null;
      // verify the required parameter 'checklistId' is set
      if (checklistId === undefined || checklistId === null) {
        throw new Error("Missing the required parameter 'checklistId' when calling toEvaluate");
      }

      let pathParams = {
        'checklistId': checklistId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = RestBodyResponseUtil;

      return this.apiClient.callApi(
        '/api/checklist/{checklistId}/to-evaluate', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the toggleChecklistVisibilityOnBI operation.
     * @callback moduleapi/ChecklistServicesApi~toggleChecklistVisibilityOnBICallback
     * @param {String} error Error message, if any.
     * @param {module:model/RestBodyResponseUtil{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Toggle BI visibility of checklist by id
     * Toggle visibility ot the selected checklist from the BI dashboard
     * @param {Number} checklistId 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.flagVisible  (default to <.>)
     * @param {module:api/ChecklistServicesApi~toggleChecklistVisibilityOnBICallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    toggleChecklistVisibilityOnBI(checklistId, flagVisible, callback) {
      // opts = opts || {};
      flagVisible = !(flagVisible === null || flagVisible === undefined) ? flagVisible : true;

      let postBody = null;
      // verify the required parameter 'checklistId' is set
      if (checklistId === undefined || checklistId === null) {
        throw new Error("Missing the required parameter 'checklistId' when calling toggleChecklistVisibilityOnBI");
      }

      let pathParams = {
        'checklistId': checklistId
      };
      let queryParams = {
        'flagVisible': flagVisible
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = RestBodyResponseUtil;

      return this.apiClient.callApi(
        '/api/checklist/{checklistId}/toggle-visibility-on-bi', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the unconfirm operation.
     * @callback moduleapi/ChecklistServicesApi~unconfirmCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RestBodyResponseUtil{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Set checklist state from &#x27;Evaluated&#x27;/&#x27;Confirmed&#x27; to &#x27;WIP&#x27; by id
     * Request to change the status of a checklist from &#x27;Evaluated&#x27;/&#x27;confirmed&#x27; to &#x27;WIP&#x27; based on the id passed as path variable. The user must be a SU to use this request.
     * @param {Number} checklistId 
     * @param {module:api/ChecklistServicesApi~unconfirmCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    unconfirm(checklistId, callback) {
      
      let postBody = null;
      // verify the required parameter 'checklistId' is set
      if (checklistId === undefined || checklistId === null) {
        throw new Error("Missing the required parameter 'checklistId' when calling unconfirm");
      }

      let pathParams = {
        'checklistId': checklistId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = RestBodyResponseUtil;

      return this.apiClient.callApi(
        '/api/checklist/{checklistId}/unconfirm', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updateChecklist operation.
     * @callback moduleapi/ChecklistServicesApi~updateChecklistCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ChecklistDTO{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update checklist by info from body
     * Request to update the checklist info based on the same request (ChecklistPostRequestDTO) and response of the POST request in the same path. The only difference is that you must include the id in the body. If the status of the Checklist is &#x27;Confirmed&#x27; it will be changed in &#x27;Under Review&#x27;.
     * @param {module:model/ChecklistPostRequestDTO} body 
     * @param {Number} checklistId 
     * @param {module:api/ChecklistServicesApi~updateChecklistCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    updateChecklist(body, checklistId, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling updateChecklist");
      }
      // verify the required parameter 'checklistId' is set
      if (checklistId === undefined || checklistId === null) {
        throw new Error("Missing the required parameter 'checklistId' when calling updateChecklist");
      }

      let pathParams = {
        'checklistId': checklistId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['*/*'];
      let returnType = ChecklistDTO;

      return this.apiClient.callApi(
        '/api/checklist/{checklistId}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updateChecklistHierarchy operation.
     * @callback moduleapi/ChecklistServicesApi~updateChecklistHierarchyCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RestBodyResponseUtil{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update checklist COSO hierarchy by id and body
     * Request to update the full COSO hierarchy (qualitative/quantitative questions) associated to a checklist based on the id passed as path variable and the body holding an array of FattoreQualificanteDTO. The status of the checklist will be set as &#x27;Work in Progress&#x27; (WIP).
     * @param {Array.<module:model/ChecklistCosoFattoreQualificanteDTO>} body 
     * @param {Number} checklistId 
     * @param {module:api/ChecklistServicesApi~updateChecklistHierarchyCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    updateChecklistHierarchy(body, checklistId, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling updateChecklistHierarchy");
      }
      // verify the required parameter 'checklistId' is set
      if (checklistId === undefined || checklistId === null) {
        throw new Error("Missing the required parameter 'checklistId' when calling updateChecklistHierarchy");
      }

      let pathParams = {
        'checklistId': checklistId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['*/*'];
      let returnType = RestBodyResponseUtil;

      return this.apiClient.callApi(
        '/api/checklist/{checklistId}/question', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}